import React from "react";
import { Card, Typography } from "antd";

const { Text } = Typography;

export default function LogsCard({ logs = [], title = "📋 Logs" }) {
  return (
    <Card
      size="small"
      title={
        <span>
          {title}
        </span>
      }
      style={{ marginTop: 15 }}
    >
      <div
        style={{
          border: "1px solid #f0f0f0",
          borderRadius: 6,
          padding: 12,
          height: "55vh",
          overflowY: "auto",
          background: "#fafafa",
        }}
      >
        {logs.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              color: "#9ca3af",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Nenhum log disponível.
          </div>
        ) : (
          <ul style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {logs.map((log, idx) => {
              if (typeof log.sucesso === "boolean") {
                return (
                  <li
                    key={idx}
                    style={{
                      padding: 6,
                      borderRadius: 4,
                      fontSize: 12,
                      color: log.sucesso ? "#15803d" : "#b91c1c",
                      backgroundColor: log.sucesso ? "#dcfce7" : "#fef2f2",
                    }}
                  >
                    {log.numero_linha && (
                      <strong> Linha {log.numero_linha}: </strong>
                    )}
                    {log.sucesso
                      ? `Registro criado: ${log.cnpj}`
                      : log.erro}
                  </li>
                );
              }

              return (
                <li
                  key={idx}
                  style={{
                    padding: 6,
                    borderRadius: 4,
                    color:
                      log.type === "error"
                        ? "#b91c1c"
                        : log.type === "success"
                        ? "#15803d"
                        : "#2563eb",
                    backgroundColor:
                      log.type === "error"
                        ? "#fef2f2"
                        : log.type === "success"
                        ? "#dcfce7"
                        : "#dbeafe",
                  }}
                >
                  {log.numero_linha && (
                    <strong> Linha {log.numero_linha}: </strong>
                  )}
                  {log.message}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </Card>
  );
}
